module.exports = __webpack_public_path__ + "assets/img/NPC008.d2e4f0e7.png";